import { render } from "./_DND.vue?vue&type=template&id=7b8aa2b6"
import script from "./_DND.vue?vue&type=script&lang=js"
export * from "./_DND.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__